"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectWithDigitalHig = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _caretDown = _interopRequireDefault(require("@digital-hig/icon/lib/esm/ui-controls/caret-down"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _Select = _interopRequireDefault(require("@mui/material/Select"));
var _optionContent = _interopRequireDefault(require("./option-content"));
var _SvgIcon = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _excluded = ["children", "MenuProps", "options", "style", "value", "width"],
  _excluded2 = ["children", "value"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var selectWithDigitalHig = exports.selectWithDigitalHig = function selectWithDigitalHig(BaseMuiSelect) {
  var Select = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
    var children = _ref.children,
      MenuProps = _ref.MenuProps,
      options = _ref.options,
      style = _ref.style,
      value = _ref.value,
      width = _ref.width,
      otherProps = _objectWithoutProperties(_ref, _excluded);
    // API: https://mui.com/material-ui/api/select/
    var muiApiPresets = {
      // autoWidth
      // children,
      // classes,
      // defaultOpen,
      // defaultValue,
      // displayEmpty,
      // eslint-disable-next-line react/display-name
      IconComponent: function IconComponent(props) {
        return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, props, /*#__PURE__*/_react.default.createElement(_caretDown.default, null));
      },
      // id,
      // input,
      // inputProps,
      // label,
      // labelId,
      MenuProps: _objectSpread({
        anchorOrigin: {
          horizontal: "left",
          vertical: "bottom"
        },
        elevation: 0,
        transformOrigin: {
          horizontal: "left",
          vertical: "top"
        }
      }, MenuProps)
      // multiple,
      // native,
      // onChange,
      // onClose,
      // onOpen,
      // open,
      // renderValue,
      // SelectDisplayProps,
      // sx,
      // value,
      // variant
    };
    if (!options) {
      return null;
    }
    var selectWidth = width ? width : "";
    var menuWidth = width ? "calc(".concat(width, " - 4px)") : "";
    return /*#__PURE__*/_react.default.createElement(BaseMuiSelect, _extends({}, muiApiPresets, otherProps, {
      style: _objectSpread(_objectSpread({}, style), {}, {
        width: selectWidth
      }),
      value: value,
      ref: ref
    }), children || options.map(function (_ref2) {
      var children = _ref2.children,
        optionValue = _ref2.value,
        otherOptionProps = _objectWithoutProperties(_ref2, _excluded2);
      return /*#__PURE__*/_react.default.createElement(_MenuItem.default, _extends({
        key: optionValue,
        value: optionValue,
        style: {
          width: menuWidth
        }
      }, otherOptionProps), /*#__PURE__*/_react.default.createElement(_optionContent.default, {
        isSelected: value === optionValue
      }, children));
    }));
  });
  var defaultProps = {
    options: []
  };
  Select.displayName = "Select";
  Select.defaultProps = _objectSpread({}, defaultProps);
  Select.propTypes = {
    /**
     * Select children content
     */
    children: _propTypes.default.node,
    /**
     * MUI MenuProps object.
     */
    MenuProps: _propTypes.default.object,
    /**
     * The object used to create the list of options in the select dropdown. See https://mui.com/material-ui/api/menu-item/ for full set of options.
     */
    options: _propTypes.default.array,
    /**
     * Additional styles
     */
    style: _propTypes.default.object,
    /**
     * MUI Select value.
     */
    value: _propTypes.default.any,
    /**
     * Fixed width value.
     */
    width: _propTypes.default.string
  };
  return Select;
};
var SelectDhig = selectWithDigitalHig(_Select.default);
var _default = exports.default = SelectDhig;